/**
 * UpgradeSuccessView — Page yang user nampak selepas hantar bukti bayar via PricingView.
 * Tunjuk confirmation + butang WhatsApp untuk chase admin (kalau nak cepat).
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle2, MessageCircle, Clock, ArrowLeft } from 'lucide-react';
import { auth } from '../firebase';
import { buildChaseAdminDeeplink } from '../utils/whatsappTemplate';

const UpgradeSuccessView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = auth.currentUser?.email || '';
  // amount + flow dibawa dari PricingView masa submit (state) — prefill WhatsApp ikut bayaran sebenar.
  const chaseUrl = buildChaseAdminDeeplink({
    email,
    amountSen: location.state?.amountSen,
    flowAddon: location.state?.flowAddon,
  });

  return (
    <div
      className="min-h-screen min-h-[100dvh] flex flex-col bg-gradient-to-br from-emerald-50 via-white to-green-50 relative overflow-hidden"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gradient-to-br from-emerald-200/40 to-green-200/30 rounded-full blur-3xl pointer-events-none" />

      <main className="relative z-10 flex-1 flex items-center justify-center px-4 py-6">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-3xl border-2 border-emerald-300 shadow-xl shadow-emerald-500/10 p-6 sm:p-8">
            {/* Tick icon */}
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-emerald-500 to-green-500 flex items-center justify-center shadow-lg shadow-emerald-500/40">
                <CheckCircle2 className="w-9 h-9 sm:w-11 sm:h-11 text-white" strokeWidth={2.5} />
              </div>
            </div>

            <h2 className="text-center text-xl sm:text-2xl font-extrabold text-slate-800 mb-2">
              Berjaya Hantar! 🎉
            </h2>
            <p className="text-center text-sm text-slate-500 mb-6 leading-relaxed">
              Admin akan aktifkan akaun anda dalam masa terdekat. Anda akan terima maklumat di WhatsApp.
            </p>

            {/* Info box */}
            <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 mb-5">
              <div className="flex items-start gap-2.5">
                <Clock className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
                <div className="text-xs text-amber-900 leading-relaxed">
                  <strong className="font-bold">Masa proses:</strong> 1-24 jam selepas pengesahan admin. Pastikan WhatsApp anda aktif.
                </div>
              </div>
            </div>

            {/* WhatsApp chase CTA */}
            <a
              href={chaseUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full py-3.5 rounded-xl font-extrabold text-sm transition-all flex items-center justify-center gap-2 cursor-pointer bg-gradient-to-r from-emerald-500 to-green-500 text-white shadow-lg shadow-emerald-500/40 hover:shadow-xl hover:shadow-emerald-500/50 hover:opacity-95 active:scale-[0.98] touch-manipulation"
            >
              <MessageCircle className="w-4 h-4 fill-current" />
              <span>Wasap Admin Untuk Cepatkan Proses</span>
            </a>

            <p className="text-[11px] text-slate-400 mt-3 text-center leading-relaxed">
              Optional — admin akan tetap proses submission anda walaupun tanpa WhatsApp.
            </p>

            {/* Back to dashboard */}
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="mt-5 w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-50 transition"
            >
              <ArrowLeft className="w-4 h-4" />
              Kembali ke Dashboard
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UpgradeSuccessView;